











































import { mapState } from 'vuex';
import { Vue, Component, Prop } from 'vue-property-decorator';

import RoundInterface from '@/domains/models/Round';

@Component({
  computed: mapState('rounds', ['editData'])
})
export default class AddEditRoundFormModal extends Vue {
  public editData!: RoundInterface;
  private form: any;
  private errorMessage: string = '';

  private created() {
    this.form = this.$form.createForm(this, {
      mapPropsToFields: () => {
        let id = 0;
        let name = '';
        let shortName = '';
        let sortOrder = 0;

        if (this.editData) {
          id = this.editData.id;
          name = this.editData.name;
          shortName = this.editData.shortName;
          sortOrder = this.editData.sortOrder;
        }

        return {
          id: this.$form.createFormField({
            value: id
          }),
          name: this.$form.createFormField({
            value: name
          }),
          shortName: this.$form.createFormField({
            value: shortName
          }),
          sortOrder: this.$form.createFormField({
            value: sortOrder
          })
        };
      }
    });
  }

  private handleSubmitAction(e: any) {
    e.preventDefault();

    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.submitForm(values);
      }
    });
  }

  private handleCancel() {
    this.closeForm();
  }

  private hasErrors(fieldsError: any): boolean {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
  }

  private submitForm(payload: RoundInterface) {
    let dispatchAction = 'rounds/create';
    let successMessage = 'New round added successfully';

    // Check if it's an edit or add action
    if (this.editData && this.editData.id) {
      // Edit action
      dispatchAction = 'rounds/edit';
      successMessage = 'Round updated successfully';
    }

    this.$store
      .dispatch(dispatchAction, payload)
      .then(() => {
        this.$message.success(successMessage, 10);
        this.$store.dispatch(`rounds/fetchList`);
        this.closeForm();
      })
      .catch(err => {
        this.errorMessage = err.toString();
      });
  }

  private closeForm() {
    this.$store.dispatch('modal/hideModal');
  }
}
